import { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export default function Button({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={
        cn(
          "inline-flex items-center justify-center rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-soft transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60",
          className
        )
      }
      {...props}
    />
  );
}